export default "__VITE_ASSET__CdP6RQch__"